import { CreateTokenRequest, CreateTokenResponse } from '@libs/api-reference';
import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';
import { paymentTokenFactory } from '../../src/utils/payment';

type UseCreateBankPaymentTokenQueryParamsType = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onReject?: UseMutationConfig<{}>['onReject'];
  onSuccess?: UseMutationConfig<CreateTokenResponse>['onSuccess'];
};
type UseCreateBankPaymentData = CreateTokenRequest & { bankName: string };

export default function useCreateBankPaymentTokenQuery({
  onReject,
  onSuccess,
}: UseCreateBankPaymentTokenQueryParamsType = {}) {
  const {
    execute: createBankPaymentToken,
    isPending: isCreatingBankPaymentToken,
    ...query
  } = useMutation<CreateTokenResponse>(
    (data: UseCreateBankPaymentData) => {
      return API.createBankPaymentToken(
        paymentTokenFactory(data),
        data.bankName.toLowerCase()
      );
    },
    {
      onReject,
      onSuccess(data) {
        onSuccess?.(data);
      },
    }
  );

  return { createBankPaymentToken, isCreatingBankPaymentToken, ...query };
}
